
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/komodo-wallet/desktop/simple-view-trading",
      function () {
        return require("private-next-pages/docs/komodo-wallet/desktop/simple-view-trading/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/komodo-wallet/desktop/simple-view-trading"])
      });
    }
  